import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  categoryName: string;
  author: string;
  date: string;
  readTime: string;
  image: string;
  tags: string[];
}

export default function ArticleCard({ slug, title, excerpt, categoryName, author, date, readTime, image, tags }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${slug}`}
      className="group flex flex-col sm:flex-row gap-4 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 transition-all duration-300 overflow-hidden cursor-pointer p-4"
    >
      <div className="relative w-full sm:w-48 md:w-56 h-36 sm:h-auto flex-shrink-0 rounded-lg overflow-hidden">
        <img
          src={image}
          alt={title}
          title={`${title} - PG游戏攻略`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="flex flex-col justify-between flex-1 min-w-0">
        <div>
          <div className="flex items-center gap-2 mb-1.5">
            <span className="px-2 py-0.5 rounded-md bg-primary-100 text-primary-700 text-xs font-medium whitespace-nowrap">
              {categoryName}
            </span>
            <span className="text-xs text-foreground-500">{date}</span>
          </div>
          <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base mb-1.5 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
            {title}
          </h3>
          <p className="text-xs md:text-sm text-foreground-600 line-clamp-2 mb-2">
            {excerpt}
          </p>
        </div>
        <div className="flex items-center justify-between">
          <div className="flex flex-wrap gap-1">
            {tags.slice(0, 3).map((tag) => (
              <span key={tag} className="px-1.5 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-xs whitespace-nowrap">
                {tag}
              </span>
            ))}
          </div>
          <div className="flex items-center gap-3 text-xs text-foreground-500 whitespace-nowrap">
            <span><i className="ri-user-line mr-0.5"></i>{author}</span>
            <span><i className="ri-time-line mr-0.5"></i>{readTime}</span>
          </div>
        </div>
      </div>
    </Link>
  );
}